import { render } from "./signUp.vue?vue&type=template&id=4b1781b8&scoped=true"
import script from "./signUp.vue?vue&type=script&lang=js"
export * from "./signUp.vue?vue&type=script&lang=js"

import "./signUp.vue?vue&type=style&index=0&id=4b1781b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b1781b8"]])

export default __exports__